import styled from "styled-components";

export const H2 = styled.h2`
  padding-bottom: 25px;
`;
export const H3 = styled.h3`
  padding-bottom: 15px;
`;
